// extracted by mini-css-extract-plugin
export var container = "RichTextRender-module--container--1wyoT";
export var assetContainer = "RichTextRender-module--assetContainer--3Q05_";
export var inlineImage = "RichTextRender-module--inlineImage--1lS16";
export var blockContainer = "RichTextRender-module--blockContainer--fxLKw";
export var imagesContainer = "RichTextRender-module--imagesContainer--3gyZ5";
export var image = "RichTextRender-module--image--27ZAV";